import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const formValidatorStoreSlice = createSlice({
  name: "formValidatorStore",
  initialState: {},
  reducers: {
    // The payload is a `useFormValidator` handle (a bag of closures). The slice state stays the
    // inferred `{}` of `initialState`, which is what questionFields assigns into its
    // `FieldValidatorHandle` local — declaring the handle's shape here would narrow that.
    setFormvalidatorStore: (_state, action: PayloadAction<object>) => action.payload,
  },
});

export const { setFormvalidatorStore } = formValidatorStoreSlice.actions;

export const formValidatorStore = formValidatorStoreSlice.reducer;

export default formValidatorStoreSlice.reducer;
